import React, { useEffect } from 'react';
import { Container, Sponsor, Apoio, SponsorGrid, ApoioGrid } from './styles';

const apoios = [
  { image: '/assets/evento/apoio/esa.png', url: '' },
  { image: '/assets/evento/apoio/apmpa.jpg', url: '' },
  { image: '/assets/evento/apoio/ceape.jpg', url: '' },
  { image: '/assets/evento/apoio/cesa.jpg', url: '' },
  { image: '/assets/evento/apoio/curcamp.png', url: '' },
  { image: '/assets/evento/apoio/escola_direito.png', url: '' },
  { image: '/assets/evento/apoio/FSG.png', url: '' },
  { image: '/assets/evento/apoio/igade.jpeg', url: '' },
  { image: '/assets/evento/apoio/imed.png', url: '' },
  { image: '/assets/evento/apoio/ipa.png', url: '' },
  { image: '/assets/evento/apoio/sinda.png', url: '' },
  { image: '/assets/evento/apoio/uniftec.png', url: '' },
  { image: '/assets/evento/apoio/unijui.jpeg', url: '' },
];

export const sponsors = [];

const FooterLayout: React.FC = ({ children }) => {
  return (
    <>
      <Container>
        <h2>Todos os direitos reservados - 2020</h2>
      </Container>
    </>
  );
};

export default FooterLayout;
